import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Layout, styles } from "../../../layout"; // adjust path as needed

const scriptCode = `function sendFormEmail() {
  var form = FormApp.getActiveForm();
  var formUrl = form.getPublishedUrl();
  var emailSubject = "Fill out Daily Checklist Now";
  var emailBody = "Please complete this form: " + formUrl;
  var recipients = "jackbrucepearson@gmail.com, rachael.hass31@gmail.com";
  
  MailApp.sendEmail(recipients, emailSubject, emailBody);
}

function createTimeDrivenTrigger() {
  var triggers = ScriptApp.getProjectTriggers();
  for (var i = 0; i < triggers.length; i++) {
    if (triggers[i].getHandlerFunction() === 'sendFormEmail') {
      ScriptApp.deleteTrigger(triggers[i]);
    }
  }

  ScriptApp.newTrigger('sendFormEmail')
    .timeBased()
    .atHour(21)
    .everyDays(1)
    .create();
}`;

const HardProjectSummary: React.FC = () => {
  return (
    <Layout title="75 Hard – Project Summary">
      <p style={styles.paragraph}>
        This is an old project I did with a few key elements:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>A Google Form was emailed to
          Rachael and me daily to track progress.
        </li>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          The data auto-uploaded to a Google Sheet and displayed on this site.
        </li>
        <p style={styles.paragraph}>I learned how to:</p>
        <li style={styles.listItem}>
          <ul style={{ ...styles.list }}>
            <li style={styles.listItem}>
              <span style={styles.bulletIcon}>•</span>
              Display Google Sheets data on my site as a backend
            </li>
            <li style={styles.listItem}>
              <span style={styles.bulletIcon}>•</span>
              Automate emails using Google Apps Script
            </li>
          </ul>
        </li>
      </ul>

      <div style={{ width: "100%", overflowX: "auto", marginBottom: "30px" }}>
        <SyntaxHighlighter
          language="javascript"
          style={tomorrow}
          customStyle={{
            fontSize: "14px",
            lineHeight: "1.5",
            padding: "15px",
            borderRadius: "4px",
            backgroundColor: "#2d2d2d",
            boxSizing: "border-box",
            minWidth: "100%",
          }}
        >
          {scriptCode}
        </SyntaxHighlighter>
      </div>
    </Layout>
  );
};

export default HardProjectSummary;
